import React, { useEffect } from "react";
import {useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import httpToken from "../../api/httpToken";
import GetEndPoints from "../../api/AppSetting";
import UsuarioAuth from "../../components/classes/UsuarioAuth";
import { createHttpHeaders } from "../../api/httpHeaders";

export const AzureSignOn = () => {

    const apiServico: string = "PORTAL";
    const urlAut: string = "Autenticacao/AutenticarSSO";
    const autCacheKey: string = "AutUser";
    const usuCacheKey = 'UsuarioCache';
    const navigate = useNavigate();

    function useQuery() {
        const { hash } = useLocation();
        return React.useMemo(() => new URLSearchParams(hash), [hash]);
    }

    const query = useQuery();    

    let _token: string = String(query.get("id_token")?.valueOf() === undefined ? "" : query.get("id_token")?.valueOf());
    let _token1: string = String(window.location.href);
        
    if (_token1.length > 0) {
       let indexof : Number = _token1.indexOf('#id_token=');
       let indexofEnd : Number = _token1.indexOf('&state=');
       if (indexof > 0)                                
          _token = _token1.substring(Number(indexof) + 10,  Number(indexofEnd));                                     
    }   

    var baseURL = GetEndPoints(apiServico) + urlAut + "?jtoken=" + _token;
    var result: boolean = false;    
    useEffect(() => {
     axios.post(baseURL, null, { headers: createHttpHeaders(false) })
                .then(function (response):boolean {
                     if (response.status === 200) {                        
                        const retorno : string[] = JSON.parse(JSON.stringify(response.data));                 
                        const user: UsuarioAuth = JSON.parse(JSON.stringify(retorno[0]));
                        if (retorno.length === 3) {  
                             localStorage.setItem(autCacheKey, retorno[0]);
                             localStorage.setItem(usuCacheKey, retorno[1]);                             
                             localStorage.setItem((new httpToken()).cacheKey, retorno[2]);
                             result = true;       
                            }
                       }
                        return result; })
                .catch(function (error): boolean { 
                                console.log(error); 
                                result = false;
                                return result;
                            })
                .finally(() => {
                    if (!result) {
                      localStorage.clear();  
                      navigate('/forbidden') 
                    }
                    else
                     navigate('/');
                    return result
                });
            },[]);

            return (<span></span>)
}